import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Section Component
 * Provides a consistent layout for each step in the CTI analysis process
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icon to display in the header
 * @param {string} props.title - Section title
 * @param {React.ReactNode} props.children - Section content
 * @param {number} props.step - Step number to display
 */
const Section = ({ icon, title, children, step }) => {
    const { t } = useTranslation();
    
    return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8 transition-all duration-500 ease-in-out">
        <div className="flex items-center mb-6">
            <div className="flex items-center justify-center bg-indigo-100 text-indigo-600 rounded-full h-12 w-12 mr-4">
                {icon}
            </div>
            <div>
                <p className="text-sm font-semibold text-indigo-600">{t('common.steps.step')} {step}</p>
                <h2 className="text-xl font-bold text-gray-800">{title}</h2>
            </div>
        </div>
        {children}
    </div>
);
};

export default Section;